import { em } from 'polished'
import styled from 'styled-components'

import { Col } from 'styles/components/layout'

export const Content = styled.div`
  color: ${p => p.theme.colors.white};
  padding-bottom: ${em(140)};
  text-align: center;

  ${p => p.theme.mq.upMd} {
    margin: 0 auto;
    max-width: ${em(608)};
    width: 79%;
  }

  ${p => p.theme.mq.upLg} {
    max-width: none;
    width: auto;
    text-align: left;
    padding-bottom: 0;
  }
`

export const Chart = styled.div`
  position: relative;
  min-height: ${em(250)};
  left: -${p => p.theme.indents.baseIndentXs};

  ${p => p.theme.mq.upMd} {
    left: -${p => p.theme.indents.baseIndentMd};
  }

  ${p => p.theme.mq.upLg} {
    height: 85%;
    min-height: ${em(529)};
    left: ${em(20)};
  }
`

export const ColForChart = styled(Col)`
  ${p => p.theme.mq.upLg} {
    border-bottom: ${em(1)} solid ${p => p.theme.colors.whiteOp1};
  }
`
